import { AuthContextProps } from "../components/auth-context";
import { getData, postData } from "./core";

export default class WithdrawPrintApi {
  static uri = "n/accounts/withdrawPrint";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(id: number) {
    return getData({
      id: id,
      uri: WithdrawPrintApi.uri,
      context: this.context,
    });
  }

  post(data: number) {
    return postData({
      uri: WithdrawPrintApi.uri,
      context: this.context,
      data: { Id: data },
    });
  }
}
